import { useState, useEffect } from 'react';
import { fetchPlanslist } from '../api/plan';

export const NOT_PURCHASED = 0;
export const PURCHASED = 1;
export const CANCELED = 2;

export function usePlans() {
  const [oneTimeOptions, setOneTimeOptions] = useState([]);
  const [subscriptionOptions, setSubscriptionOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPlans = async () => {
      try {
        const data = await fetchPlanslist();
        setOneTimeOptions(data.oneTimeOptions || []);
        setSubscriptionOptions(data.subscriptionOptions || []);
      } catch (error) {
        console.error('プラン取得エラー:', error);
      } finally {
        setLoading(false);
      }
    };
    loadPlans();
  }, []);

  const getPlanName = (price_id) => {
    const allPlans = [...oneTimeOptions, ...subscriptionOptions];
    const plan = allPlans.find((p) => p.price_id === price_id);
    return plan?.name || '未設定';
  };

  return { oneTimeOptions, subscriptionOptions, loading, getPlanName };
}
